var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_364_244",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_364_244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.792 29.75C15.6254 29.75 15.4587 29.7223 15.292 29.667C15.1254 29.611 14.9724 29.5137 14.833 29.375L7.41703 21.958C7.13903 21.6807 7.00703 21.3407 7.02103 20.938C7.03503 20.5347 7.16703 20.1943 7.41703 19.917C7.69436 19.667 8.02069 19.542 8.39603 19.542C8.77069 19.542 9.09703 19.667 9.37503 19.917L15.792 26.375L30.583 11.583C30.861 11.3057 31.1944 11.167 31.583 11.167C31.9724 11.167 32.3057 11.3057 32.583 11.583C32.861 11.833 33 12.1597 33 12.563C33 12.9657 32.861 13.292 32.583 13.542L16.792 29.375C16.6254 29.5137 16.4654 29.611 16.312 29.667C16.1594 29.7223 15.986 29.75 15.792 29.75Z",
    fill: "#70E5D0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.aa78bbc00fe566e5b9ed490be905a883.svg";
export { ForwardRef as ReactComponent };